import React, { Component } from "react";
import Fade from "react-reveal";
import Zmage from "react-zmage";



class Accomodation extends Component {
  render() {
    if (!this.props.data) return null;

    const profilepic = "images/" + this.props.data.image;
    const noclegiuwaga = this.props.data.noclegiuwaga; 
    const accomodation = this.props.data.accomodation;
    const plan = "images/" + this.props.data.plan;


    return (
      <section id="accomodation">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Zlot Miłośników Rowerów Poziomych"
              />

              <p className="address">
                <span>Ośrodek Rekreacyjno-Wypoczynkowy<br />
                “JAŁOWCE”</span>
                <br />
                <span>
                Kozłów 12c
                  <br />
                39-200 Dębica
                </span>

              </p>
            </div>
            <div className="nine columns main-col">
              <h2>Noclegi</h2>

              <p>{accomodation} <br />
              </p>

              <div className="attention-text">
                WAŻNE:<br/>Po przybyciu na miejsce i przywitaniu się trzeba będzie się zameldować w biurze ośrodka, umieścić opłatę za noclegi oraz odebrać klucze od pokoi/domków
                <br />Za śniadania płacimy z góry!<br/>
                Żeby cały zabieg poszedł sprawnie i nie było zamieszania z płatnościami elektronicznymi biuro przyjmuje <b>gotówkę</b><br/>
              </div> 
              <p>
                <h3>CENNIK:</h3>
                <br/>ceny mogą się delikatnie zmienić (raczej nie powinny ale …)

                <h4>Apartamenty:</h4>
                <b>Pokój 2-osobowy z łazienką</b> - 200 zł/ pokój/ doba<br />

                <h4>Domki:</h4>
                <b>Domek 10-osobowy (3 pokoje: 2os., 4 os., 4 os.) z łazienką, kuchnią i tarasem  </b>- 550 zł/ doba/ domek<br />
                <b>Domek 5-osobowy (1 duży pokój) z łazienką, kuchnią i tarasem </b>- 300 zł/ doba/ domek<br />
                <b>Dostawka w domku  </b>- 25 zł / łóżko<br />

                <h4>Pole namiotowe:</h4>
                <b>1 osoba</b> - 20 zł <br />
                <b>Ustawienie namiotu</b> - 20 zł<br />
                <b>Kąpiel pod natryskiem</b> - 7 zł<br />

                <h4>Wyżywienie:</h4>
                <b>Śniadanie w formie szwedzkiego stołu ok. 40- 45 zł/os ( wędlina, sery, chleb,
                  masło, jajecznica lub parówki, warzywa, kawa, herbata)</b>

                <h4>INNE:</h4>
                <b>* istnieje możliwość zaparkowania rowerów pod dachem jak również
                schowania w pomieszczeniu zamkniętym</b><br />
                <b>* możliwość korzystania z boiska do piłki nożnej plażowej, siatkówki plażowej,
                stołów do tenisa stołowego (w cenie pobytu)</b><br />
                <b>* możliwość korzystania z rowerków wodnych (35 zł / rowerek 2/3-osobowy) oraz
                kajaków (20 zł / kajak 2-osobowy)</b>
                                
              </p>

            </div>

          </div>
          {/* <img className="plan-img"
            src={plan}
            alt="Plan ośrodka"
          /> */}
        </Fade>
      </section>
    );
  }
}

export default Accomodation;
